/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardStatusResponseDto,
  DashboardStreakResponseDto,
  GetDashboardStatusQueryControllerGetStatusParams,
  GetDashboardStreakQueryControllerGetStreakParams,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Get the consolidated dashboard status for a nursery
 */
export const getDashboardStatusQueryControllerGetStatus = (
  nurseryId: string,
  params?: GetDashboardStatusQueryControllerGetStatusParams,
  signal?: AbortSignal,
) => {
  return axiosClient<DashboardStatusResponseDto>({
    url: `/v1/nurseries/${nurseryId}/dashboard/status`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDashboardStatusQueryControllerGetStatusQueryKey = (
  nurseryId: string,
  params?: GetDashboardStatusQueryControllerGetStatusParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/dashboard/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDashboardStatusQueryControllerGetStatusQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStatusQueryControllerGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDashboardStatusQueryControllerGetStatusQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>
  > = ({ signal }) =>
    getDashboardStatusQueryControllerGetStatus(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardStatusQueryControllerGetStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>
>;
export type GetDashboardStatusQueryControllerGetStatusQueryError = unknown;

export function useGetDashboardStatusQueryControllerGetStatus<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | GetDashboardStatusQueryControllerGetStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
          >,
          TError,
          Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDashboardStatusQueryControllerGetStatus<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStatusQueryControllerGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
          >,
          TError,
          Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDashboardStatusQueryControllerGetStatus<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStatusQueryControllerGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the consolidated dashboard status for a nursery
 */

export function useGetDashboardStatusQueryControllerGetStatus<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusQueryControllerGetStatus>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStatusQueryControllerGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStatusQueryControllerGetStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDashboardStatusQueryControllerGetStatusQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a nursery's current on-time streak
 */
export const getDashboardStreakQueryControllerGetStreak = (
  nurseryId: string,
  params?: GetDashboardStreakQueryControllerGetStreakParams,
  signal?: AbortSignal,
) => {
  return axiosClient<DashboardStreakResponseDto>({
    url: `/v1/nurseries/${nurseryId}/dashboard/streak`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDashboardStreakQueryControllerGetStreakQueryKey = (
  nurseryId: string,
  params?: GetDashboardStreakQueryControllerGetStreakParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/dashboard/streak`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDashboardStreakQueryControllerGetStreakQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStreakQueryControllerGetStreakParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDashboardStreakQueryControllerGetStreakQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>
  > = ({ signal }) =>
    getDashboardStreakQueryControllerGetStreak(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardStreakQueryControllerGetStreakQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>
>;
export type GetDashboardStreakQueryControllerGetStreakQueryError = unknown;

export function useGetDashboardStreakQueryControllerGetStreak<
  TData = Awaited<
    ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | GetDashboardStreakQueryControllerGetStreakParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
          >,
          TError,
          Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDashboardStreakQueryControllerGetStreak<
  TData = Awaited<
    ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStreakQueryControllerGetStreakParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
          >,
          TError,
          Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDashboardStreakQueryControllerGetStreak<
  TData = Awaited<
    ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStreakQueryControllerGetStreakParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a nursery's current on-time streak
 */

export function useGetDashboardStreakQueryControllerGetStreak<
  TData = Awaited<
    ReturnType<typeof getDashboardStreakQueryControllerGetStreak>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetDashboardStreakQueryControllerGetStreakParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardStreakQueryControllerGetStreak>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDashboardStreakQueryControllerGetStreakQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
